<template>
  <div class="library__view">
    <h1 class="library__title">Components</h1>

    <section id="search" class="library__section">
      <b-row>
        <b-col>
          <b-form-group label="Ricerca" label-class="vb-label">
            <vb-input
              v-model="search"
              :vb_options="{
                autocomplete: 'chrome-off',
              }"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </section>

    <!-- section buttons -->
    <section
      id="buttons"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Buttons') }"
    >
      <p class="library__section-title">
        <highlight-match text="Buttons" :search="search" />
      </p>

      <div>
        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large primary',
            variant: 'primary',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large secondary',
            variant: 'secondary',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large cta',
            variant: 'cta',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large vb-color-1',
            variant: 'vb-color-1',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large vb-color-2',
            variant: 'vb-color-2',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>
      </div>

      <div class="mt-4">
        <vb-button
          class="shadow-lg"
          :vb_options="{
            text: 'large info',
            variant: 'info',
            size: 'lg',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          :vb_options="{
            text: 'large disabled',
            size: 'lg',
            disabled: true,
            icon_disabled: 'lock',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow"
          :vb_options="{
            text: 'default dark',
            variant: 'dark',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow"
          :vb_options="{
            text: 'default icon',
            variant: 'info',
            icon: 'airplane',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-sm"
          :vb_options="{
            text: 'small light',
            variant: 'light',
            size: 'sm',
          }"
        />

        <span class="mr-3"></span>

        <vb-button
          class="shadow-sm"
          :vb_options="{
            text: 'small outline primary',
            variant: 'outline-primary',
            size: 'sm',
          }"
        />
      </div>
    </section>

    <!-- section radio button -->
    <section
      id="range-slider"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Range slider') }"
    >
      <p class="library__section-title">
        <highlight-match text="Range slider" :search="search" />
      </p>

      <div class="d-flex align-items-center">
        <vb-range-slider
          class="ml-4"
          :vb_options="{
            min: 65,
            max: 2004,
            inputs: true,
            items: Object.values({
              '0': {
                min: '65.60',
                max: '99.96',
                count: 44,
              },
              '100': {
                min: '100.13',
                max: '199.67',
                count: 480,
              },
              '200': {
                min: '200.00',
                max: '299.70',
                count: 378,
              },
              '300': {
                min: '300.00',
                max: '399.00',
                count: 154,
              },
              '400': {
                min: '400.51',
                max: '499.98',
                count: 80,
              },
              '500': {
                min: '500.00',
                max: '599.00',
                count: 53,
              },
              '600': {
                min: '601.82',
                max: '698.70',
                count: 26,
              },
              '700': {
                min: '704.34',
                max: '798.62',
                count: 10,
              },
              '800': {
                min: '801.90',
                max: '891.00',
                count: 17,
              },
              '900': {
                min: '900.00',
                max: '991.97',
                count: 7,
              },
              '1000': {
                min: '1000.00',
                max: '1086.75',
                count: 3,
              },
              '1100': {
                min: '1101.61',
                max: '1193.51',
                count: 5,
              },
              '1200': {
                min: '1203.80',
                max: '1222.66',
                count: 3,
              },
              '1300': {
                min: '1310.62',
                max: '1356.54',
                count: 2,
              },
              '1400': {
                min: '1440.00',
                max: '1456.55',
                count: 2,
              },
              '1500': {
                min: '1500.00',
                max: '1561.45',
                count: 4,
              },
              '1600': {
                min: '1619.20',
                max: '1619.20',
                count: 1,
              },
              '1700': {
                min: '1715.00',
                max: '1715.00',
                count: 1,
              },
              '1800': {
                min: '1800.00',
                max: '1897.71',
                count: 4,
              },
              '1900': {
                min: '1932.30',
                max: '1949.38',
                count: 2,
              },
              '2000': {
                min: '2003.11',
                max: '2003.11',
                count: 1,
              },
            }),
          }"
        />

        <vb-range-slider
          class="ml-4"
          :vb_options="{
            inputs: true,
            min: 55,
            max: 1680,
            items: Object.values({
              0: {
                count: 19,
              },
              100: {
                count: 279,
              },
              200: {
                count: 250,
              },
              300: {
                count: 127,
              },
              400: {
                count: 45,
              },
              500: {
                count: 26,
              },
              600: {
                count: 21,
              },
              700: {
                count: 9,
              },
              800: {
                count: 2,
              },
              900: {
                count: 2,
              },
              1000: {
                count: 1,
              },
              1100: {
                count: 2,
              },
              1300: {
                count: 3,
              },
              1400: {
                count: 4,
              },
              1600: {
                count: 2,
              },
            }),
          }"
        />
      </div>
    </section>

    <!-- section steps bar -->
    <section
      id="steps-bar"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Steps bar') }"
    >
      <p class="library__section-title">
        <highlight-match text="Steps bar" :search="search" />
      </p>

      <div class="library__steps-control d-flex flex-wrap align-items-end mb-3">
        <b-form-group
          class="mb-0 mr-3"
          label="Numero di step"
          label-for="library__steps-count"
          label-class="vb-label"
        >
          <b-form-input
            id="library__steps-count"
            v-model.number="step_count"
            class="library__steps-count"
            type="number"
            min="1"
            max="12"
          />
        </b-form-group>

        <b-form-group
          class="mb-0 mr-3"
          label="Allineamento"
          label-for="library__steps-alignment"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              id: 'library__steps-alignment',
              options: alignment_options,
              value: steps_alignment,
            }"
            @change="steps_alignment = $event"
          />
        </b-form-group>

        <color-picker
          id="steps-demo-color"
          v-model="steps_color"
          :options="color_options"
        />

        <b-form-group
          class="mb-0 mr-3"
          label="Simbolo (px)"
          label-for="library__steps-symbol-size"
          label-class="vb-label"
        >
          <b-form-input
            id="library__steps-symbol-size"
            v-model.number="steps_symbol_size"
            class="library__steps-count"
            type="number"
            min="12"
            max="60"
          />
        </b-form-group>

        <b-form-group
          class="mb-0 mr-3"
          label="Linea (px)"
          label-for="library__steps-line-thickness"
          label-class="vb-label"
        >
          <b-form-input
            id="library__steps-line-thickness"
            v-model.number="steps_line_thickness"
            class="library__steps-count"
            type="number"
            min="1"
            max="12"
            step="0.5"
          />
        </b-form-group>

        <vb-button
          :vb_options="{ text: 'Applica', variant: 'info' }"
          @click="build_steps_demo"
        />
      </div>

      <steps-bar
        :steps="steps_demo"
        :active_id="active_step_id"
        :enabled_ids="visited_step_ids"
        :completed_ids="completed_step_ids"
        :customizations="steps_customizations"
        @select="set_active_step"
      />

      <div v-if="active_step" class="library__steps-body">
        <p class="library__steps-heading">
          <b>{{ active_step.name }}</b> di {{ steps_demo.length }}
        </p>
        <p class="text--muted text--small mb-3">
          Attiva il requisito per sbloccare il pulsante «Continua».
        </p>

        <vb-checkbox
          :key="`${active_step_id}-${reset_token}`"
          :vb_options="{
            switch: true,
            type: 'light',
            text: 'Requisiti dello step soddisfatti',
            value: step_gates[active_step_id],
          }"
          @change="set_step_gate(active_step_id, $event)"
        />

        <div class="library__steps-actions mt-4">
          <vb-button
            :vb_options="{
              text: 'Indietro',
              variant: 'light',
              disabled: active_step_index === 0,
            }"
            @click="go_back"
          />

          <span class="mr-2"></span>

          <vb-button
            :vb_options="{
              text: continue_label,
              variant: 'primary',
              disabled: !can_continue,
            }"
            @click="advance"
          />

          <span class="mr-2"></span>

          <vb-button
            :vb_options="{ text: 'Reset', variant: 'outline-primary' }"
            @click="reset_steps_demo"
          />
        </div>
      </div>
    </section>

    <!-- section radio button -->
    <section
      id="radio"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Radio') }"
    >
      <p class="library__section-title">
        <highlight-match text="Radio" :search="search" />
      </p>

      <div class="d-flex align-items-center">
        <vb-radio
          :vb_options="{
            text: 'Radio default',
            size: 'sm',
          }"
        />

        <span class="mr-3"></span>

        <vb-radio
          :vb_options="{
            text: 'Radio disabled',
            disabled: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-radio
          :vb_options="{
            text: 'Radio light default',
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-radio
          :vb_options="{
            text: 'Radio light disabled',
            type: 'light',
            disabled: true,
          }"
        />
      </div>
    </section>

    <!-- section checkbox -->
    <section
      id="checkbox"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Checkbox') }"
    >
      <p class="library__section-title">
        <highlight-match text="Checkbox" :search="search" />
      </p>

      <color-picker
        id="checkbox-demo-color"
        v-model="checkbox_color"
        class="mb-3"
        :options="checkbox_color_options"
      />

      <div class="d-flex align-items-center mb-3">
        <vb-checkbox
          :vb_options="{
            text: 'Checkbox colore selezionato',
            color: checkbox_color,
            value: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox light colore selezionato',
            type: 'light',
            color: checkbox_color,
            value: true,
          }"
        />
      </div>

      <div class="d-flex align-items-center">
        <vb-checkbox
          :vb_options="{
            text: 'Checkbox default',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox disabled',
            disabled: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox light default',
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox light disabled',
            type: 'light',
            disabled: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox color --info',
            color: '--info',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Checkbox color sass(danger)',
            color: sass('danger'),
          }"
        />
      </div>
    </section>

    <!-- section switch -->
    <section
      id="switch"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Switch') }"
    >
      <p class="library__section-title">
        <highlight-match text="Switch" :search="search" />
      </p>

      <color-picker
        id="switch-demo-color"
        v-model="switch_color"
        class="mb-3"
        :options="checkbox_color_options"
      />

      <div class="d-flex align-items-center mb-3">
        <vb-checkbox
          :vb_options="{
            text: 'Switch colore selezionato',
            switch: true,
            color: switch_color,
            value: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch light colore selezionato',
            switch: true,
            type: 'light',
            color: switch_color,
            value: true,
          }"
        />
      </div>

      <div class="d-flex align-items-center">
        <vb-checkbox
          :vb_options="{
            text: 'Switch default',
            switch: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch disabled',
            disabled: true,
            switch: true,
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch light default',
            switch: true,
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch light disabled',
            disabled: true,
            switch: true,
            type: 'light',
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch color sass(success)',
            switch: true,
            color: sass('success'),
          }"
        />

        <span class="mr-3"></span>

        <vb-checkbox
          :vb_options="{
            text: 'Switch color hex',
            switch: true,
            color: 'f8af3c',
          }"
        />
      </div>
    </section>

    <!-- section input -->
    <section
      id="input"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Type Input') }"
    >
      <p class="library__section-title">
        <highlight-match text="Type Input" :search="search" />
      </p>

      <div class="w-50">
        <vb-input
          :vb_options="{
            placeholder: 'Placeholder',
          }"
        />
      </div>

      <hr class="mt-4" />

      <div class="w-50">
        <vb-input
          v-model="money"
          :vb_options="{
            required: true,
            name: 'Valore del buono',
            price: true,
            value: null,
            placeholder: '1234',
            formatter: format_price,
          }"
        />
        <small class="mb-1"><i>Valore realmente gestito: </i><b>{{ money }}</b></small>
      </div>
    </section>

    <!-- section select -->
    <section
      id="select"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Select') }"
    >
      <p class="library__section-title">
        <highlight-match text="Select" :search="search" />
      </p>

      <div class="w-50">
        <b-form-group
          label-for="select"
          label="Label select"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              options: [
                { item: null, name: 'Please select an option', disabled: true },
                { item: 'A', name: 'Option A' },
                { item: 'B', name: 'Option B' },
              ],
              value_field: 'item',
              text_field: 'name',
              value: null,
            }"
          />
        </b-form-group>
      </div>

      <hr class="mt-4" />

      <b-form inline class="vb-form">
        <b-form-group
          label-for="select"
          label="Label select inline"
          label-class="vb-label"
        >
          <vb-select
            :vb_options="{
              options: [
                { item: null, name: 'Please select an option', disabled: true },
                { item: 'A', name: 'Option A' },
                { item: 'B', name: 'Option B' },
              ],
              value_field: 'item',
              text_field: 'name',
              value: null,
            }"
          />
        </b-form-group>
      </b-form>
    </section>

    <!-- section birthdate input -->
    <section
      id="birthdate-input"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Birthdate input') }"
    >
      <p class="library__section-title">
        <highlight-match text="Birthdate input" :search="search" />
      </p>

      <div class="w-50">
        <b-form-group
          label-for="birthdate-input"
          label="Data di nascita"
          label-class="vb-label"
        >
          <birthdate-input
            v-model="birthdate"
            :min="birthdate_min"
            :max="birthdate_max"
          />
        </b-form-group>
        <small class="mb-1"><i>Valore realmente gestito: </i><b>{{ birthdate || 'null' }}</b></small>
      </div>

      <hr class="mt-4" />

      <p class="text--small text--muted mb-2">Bound opzionali: svuotali per rendere il campo illimitato. Una data fuori range viene riportata al bound più vicino (e i tre campi si riallineano al valore snappato), anche quando è un bound a spostarsi sotto una data già inserita.</p>

      <b-row>
        <b-col>
          <b-form-group label="Data minima" label-class="vb-label">
            <vb-input
              v-model="birthdate_min"
              :vb_options="{
                autocomplete: 'off',
                type: 'date',
                value: birthdate_min,
              }"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Data massima" label-class="vb-label">
            <vb-input
              v-model="birthdate_max"
              :vb_options="{
                autocomplete: 'off',
                type: 'date',
                value: birthdate_max,
              }"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <small class="mb-1"><i>Bound attivi: </i><b>{{ birthdate_min || 'nessuno' }}</b><i> … </i><b>{{ birthdate_max || 'nessuno' }}</b></small>
    </section>

    <!-- section breadcrumbs-->
    <section
      id="breadcrumbs"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Breadcrumbs') }"
    >
      <p class="library__section-title">
        <highlight-match text="Breadcrumbs" :search="search" />
      </p>

      <vb-breadcrumbs
        :vb_options="{
          items: [
            {
              text: 'Home',
              href: '#',
            },
            {
              text: 'Travel',
              href: '#',
            },
            {
              text: 'Paris',
              active: true,
            },
          ],
        }"
      />
    </section>

    <!-- section tabs-->
    <section
      id="tabs"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Tabs') }"
    >
      <p class="library__section-title">
        <highlight-match text="Tabs" :search="search" />
      </p>

      <div class="w-50">
        <vb-tabs>
          <b-tab title="Tab 01">
            <p>I'm the first tab</p>
          </b-tab>
          <b-tab title="Tab 02">
            <p>I'm the second tab</p>
          </b-tab>
        </vb-tabs>
      </div>
    </section>

    <!-- section toggle -->
    <section
      id="toggle"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Toggle') }"
    >
      <p class="library__section-title">
        <highlight-match text="Toggle" :search="search" />
      </p>

      <div class="w-50">
        <vb-toggle
          :vb_options="{
            id: 'my-toggle',
            btn_text: 'Toggle Collapse',
          }"
        >
          <p>Hello World</p>
        </vb-toggle>
      </div>
    </section>

    <!-- section accordion -->
    <section
      id="accordion"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Accordion') }"
    >
      <p class="library__section-title">
        <highlight-match text="Accordion" :search="search" />
      </p>

      <div class="w-50">
        <vb-accordion :items="accordion_items" />
      </div>
    </section>

    <!-- section notice -->
    <section
      id="notice"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Notice') }"
    >
      <p class="library__section-title">
        <highlight-match text="Notice" :search="search" />
      </p>

      <div class="w-75">
        <vb-notice
          class="mb-3"
          icon="clock"
          title="Non lasciare scadere il tuo credito welfare."
          text="Il credito welfare inutilizzato decade a fine anno."
        />
        <vb-notice icon="envelope" title="Serve aiuto con la tua prenotazione?">
          Accedi alla sezione <router-link to="/contatti">Contatti</router-link>.
        </vb-notice>
      </div>
    </section>

    <!-- section modal -->
    <section
      id="modal"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Modal') }"
    >
      <p class="library__section-title">
        <highlight-match text="Modal" :search="search" />
      </p>

      <span v-b-modal="'modal_library'" class="text-info">open modal</span>

      <vb-modal
        :vb_options="{
          id: 'modal_library',
          size: 'lg',
          title: 'I pacchetti viaggio includono',
          hide_footer: true,
        }"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
          nonummy nibh euismod tincidunt ut laore et dolore magna aliquam erat
          volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
          ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
        </p>
      </vb-modal>
    </section>

    <!-- section dropdown -->
    <section
      id="dropdown"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Dropdown') }"
    >
      <p class="library__section-title">
        <highlight-match text="Dropdown" :search="search" />
      </p>

      <vb-dropdown
        :vb_options="{
          size: 'lg',
          text: 'large info',
        }"
      >
        <b-dropdown-item>First Action</b-dropdown-item>
        <b-dropdown-item>Second Action</b-dropdown-item>
        <b-dropdown-item>Third Action</b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item>Something else here...</b-dropdown-item>
        <b-dropdown-item active>Active action</b-dropdown-item>
        <b-dropdown-item disabled>Disabled action</b-dropdown-item>
      </vb-dropdown>

      <span class="mr-3"></span>

      <vb-dropdown
        :vb_options="{
          variant: 'outline-primary',
          text: 'default outline primary',
        }"
      >
        <b-dropdown-item>First Action</b-dropdown-item>
        <b-dropdown-item>Second Action</b-dropdown-item>
        <b-dropdown-item>Third Action</b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item>Something else here...</b-dropdown-item>
        <b-dropdown-item active>Active action</b-dropdown-item>
        <b-dropdown-item disabled>Disabled action</b-dropdown-item>
      </vb-dropdown>
    </section>

    <!-- section card default (vertical)  -->
    <section
      id="cards"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Card Default (Vertical)') }"
    >
      <p class="library__section-title">
        <highlight-match text="Card Default (Vertical)" :search="search" />
      </p>

      <b-row>
        <b-col cols="4">
          <vb-card
            :card="{
              title: 'Title',
              subtitle: 'SubTitle',
              text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
              image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
            }"
          />
        </b-col>
        <b-col cols="4">
          <vb-card
            :card="{
              title: 'Title',
              subtitle: 'SubTitle',
              text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
              image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
            }"
          />
        </b-col>
        <b-col cols="4">
          <vb-card
            :card="{
              title: 'Title',
              subtitle: 'SubTitle',
              text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
              image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
            }"
          />
        </b-col>
      </b-row>
    </section>

    <!-- section card -->
    <section
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Card Horizontal') }"
    >
      <p class="library__section-title">
        <highlight-match text="Card Horizontal" :search="search" />
      </p>

      <div class="w-50">
        <vb-card
          variant="horizontal"
          :card="{
            title: 'Title',
            subtitle: 'SubTitle',
            text: 'Sed posuere consectetur est at lobor-tis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.',
            image: '/assets/images/alpitour/statics/iStock-1208856002.jpg',
          }"
        >
          <div class="mt-3">
            <a href="#">Slot content</a>
          </div>
        </vb-card>
      </div>
    </section>

    <!-- section gift card -->
    <section
      id="gift-card"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Gift Card') }"
    >
      <p class="library__section-title">
        <highlight-match text="Gift Card" :search="search" />
      </p>

      <b-row>
        <b-col cols="6">
          <gift-card
            :logo_src="gift_card_logo"
            :category="gift_card_category"
            :validity="gift_card_validity"
          />
        </b-col>
        <b-col cols="6">
          <!-- variante blu: vuole la versione bianca del marchio -->
          <gift-card
            variant="primary"
            :logo_src="gift_card_logo_white"
            :category="gift_card_category"
            :validity="gift_card_validity"
          >
            <div class="library__gift-card-value">
              <span class="library__gift-card-label">Gift Card</span>
              <span class="library__gift-card-amount">€100</span>
            </div>
          </gift-card>
        </b-col>
      </b-row>
    </section>

    <!-- section feature card (stesso componente, tre casi d'uso diversi) -->
    <section
      id="feature-card"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Feature Card') }"
    >
      <p class="library__section-title">
        <highlight-match text="Feature Card" :search="search" />
      </p>

      <b-row>
        <!-- caso 1: benefit — sfondo verde tint, titolo 14 -->
        <b-col cols="4">
          <feature-card
            icon="wallet"
            background_color="rgba(0, 188, 125, 0.1)"
            icon_background_color="linear-gradient(135deg, #00d492, #00bba7)"
            icon_color="#fff"
            :title_size="14"
            title="Acquisto semplice"
            text="Usa direttamente il tuo credito welfare aziendale, zero frizioni."
          />
        </b-col>

        <!-- caso 2: rassicurazione — titolo 16, solo caption -->
        <b-col cols="4">
          <feature-card
            icon="shield"
            icon_background_color="#e9ecef"
            radius
            title="Pagamento sicuro"
            caption="Tramite portale welfare"
            :centered="true"
          />
        </b-col>

        <!-- caso 3: info conferma — titolo 18, testo + caption -->
        <b-col cols="4">
          <feature-card
            icon="email"
            :title_size="18"
            title="Email di conferma"
            text="Riceverai una email con tutti i dettagli della tua Gift Card e le istruzioni per l'utilizzo."
            caption="Controlla anche la cartella spam se non la vedi nella posta in arrivo"
          />
        </b-col>

        <b-col cols="4" class="mt-4">
          <feature-card
            icon="email"
            title="Non hai trovato risposta?"
            text="Il nostro team prenderà in carico la tua richiesta"
            centered
          >
            <template #cta>
              <vb-button :vb_options="{ variant: 'primary', text: 'Contatta l\'assistenza' }" />
            </template>
          </feature-card>
        </b-col>
      </b-row>
    </section>

    <!-- section pointer list (stesso componente, due orientamenti) -->
    <section
      id="pointer-list"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Pointer List') }"
    >
      <p class="library__section-title">
        <highlight-match text="Pointer List" :search="search" />
      </p>

      <b-row>
        <!-- orizzontale: pallino grande sopra, titolo + descrizione centrati -->
        <b-col md="12" xl="8">
          <div class="library__pointer-list-panel">
            <pointer-list orientation="horizontal" :steps="pointer_list_steps" />
          </div>
        </b-col>

        <!-- verticale: pallino piccolo a lato, solo label -->
        <b-col md="12" xl="4">
          <div class="library__pointer-list-panel">
            <pointer-list :steps="pointer_list_short_steps" />
          </div>
        </b-col>
      </b-row>
    </section>

    <!-- section circle list -->
    <section
      id="circle-list"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Circle List') }"
    >
      <p class="library__section-title">
        <highlight-match text="Circle List" :search="search" />
      </p>

      <b-row>
        <b-col cols="12">
          <div class="library__pointer-list-panel">
            <circle-list :items="circle_list_items" />
          </div>
        </b-col>
      </b-row>
    </section>

    <!-- popover -->
    <section
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Popovers') }"
    >
      <p class="library__section-title">
        <highlight-match text="Popovers" :search="search" />
        <vb-checkbox
          class="text--base"
          :vb_options="{
            text: 'Mostra versione senza punta',
            switch: with_arrow,
            type: 'light',
          }"
          @change="toggle_popover_with_arrow"
        />
        <span class="text--muted text--small">
          Nota: Se lo schermo non permette di vedere tutto il corpo del popover la libreria di bootstrap lo posizionerà in modalità auto
        </span>
      </p>
      <b-row>
        <b-col
          v-for="popover_example in popovers"
          :key="`popover:${popover_example.variant}:${popover_example.placement}`"
          cols="3"
        >
          <div class="custom-popover">
            <div
              :id="`popover:${popover_example.variant}:${popover_example.placement}`"
              class="custom-popover--trigger"
            >
              popover {{ popover_example.variant }}
              {{ popover_example.placement }}
            </div>
            <b-popover
              :target="`popover:${popover_example.variant}:${popover_example.placement}`"
              triggers="hover"
              :placement="popover_example.placement"
              :custom-class="`b-popover--${popover_example.variant} ${with_arrow ? '' : 'b-popover--no-arrow'}`"
            >
              Popover content
            </b-popover>
          </div>
        </b-col>
      </b-row>
    </section>

    <!-- loader -->
    <section
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Loaders') }"
    >
      <p class="library__section-title">
        <highlight-match text="Loaders" :search="search" />
      </p>
      <b-row>
        <b-col cols="2">
          <p class="text--small text--muted mb-2 d-flex align-items-center">default <loader class="ml-3" /></p>
        </b-col>
        <b-col cols="2">
          <p class="text--small text--muted mb-2 d-flex align-items-center">small <loader class="ml-3" size="small" /></p>
        </b-col>
        <b-col cols="2">
          <p class="text--small text--muted mb-2 d-flex align-items-center">large <loader class="ml-3" size="large" /></p>
        </b-col>
      </b-row>
      <b-row class="mt-4 pt-2">
        <b-col cols="6">
          <p class="text-center text--small text--muted mb-4"><i>Timing slot</i> (default)</p>
          <loader 
            size="large"
            :show_timing_slot="true"
          />
        </b-col>
        <b-col cols="6">
          <p class="text-center text--small text--muted mb-4"><i>Timing slot</i> (custom)</p>
          <loader
            size="large"
            :show_timing_slot="true"
            :text_loading="loading_messages.book.messages"
            :text_footer="loading_messages.book.footer"
          />
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12">
          <p class="text--small text--muted mb-2">loader in modal (fullscreen blocking)</p>
          <vb-button
            :vb_options="{ text: 'Mostra loader-modal', variant: 'info' }"
            @click="show_loader_modal = true"
          />
          <vb-button
            v-if="show_loader_modal"
            class="ml-2"
            :vb_options="{ text: 'Chiudi (debug)', variant: 'light' }"
            @click="show_loader_modal = false"
          />
          <loader-modal :show="show_loader_modal" service="book" />
        </b-col>
      </b-row>
    </section>

    <!-- section airobot automated checkin status -->
    <section
      id="airobot-checkin"
      class="library__section"
      :class="{ 'library__section--hidden': is_hidden('Airobot - Automated Checkin status') }"
    >
      <p class="library__section-title">
        <highlight-match text="Airobot - Automated Checkin status" :search="search" />
      </p>

      <check-in-status-dev-preview />
    </section>

    <!-- section image with text cta -->
    <!--    <section class="library__section">
      <p class="library__section-title">Image with text cta</p>

      <div class="w-50">
        <image-with-text-cta
            :image_src="'assets/images/alpitour/statics/iStock-1180231917.jpg'"
            :text_heading="'Welfare non sufficiente?'"
            :text_content="'Se il tuo credito welfare non è sufficiente troviamo insieme una soluzione. <strong>Parliamo!</strong>'"
            :text_cta="[
              {
                cta_text: 'Chat',
                cta_icon: 'symbol_lb',
                cta_action: 'support',
                cta_id: 'library-demo-chat',
              },
              {
                cta_text: 'Whatsapp',
                cta_icon: 'whatsapp',
                cta_url: '#',
              },
              {
                cta_text: 'Email',
                cta_icon: 'mail',
                cta_url: 'mailto:',
              }
            ]"
        />
      </div>

    </section>-->
  </div>
</template>

<script>
import { loading_messages } from "@/resources";
import StepsBar from "../blocks/steps-bar.vue";
import HighlightMatch from "../blocks/highlight-match.vue";
import ColorPicker from "../blocks/color-picker.vue";
import CheckInStatusDevPreview from "@liveflight/components/blocks/check-in/dev-preview.vue";
import BirthdateInput from "@components/blocks/birthdate-input.vue";
import { VALIDITY_LABEL } from "@livegift/resources";
import GiftCard from "@components/blocks/gift-card.vue";
import FeatureCard from "@components/blocks/feature-card.vue";
import PointerList from "@components/blocks/pointer-list.vue";
import CircleList from "@components/blocks/circle-list.vue";
import VbAccordion from "../blocks/accordion.vue";
import VbNotice from "../blocks/notice.vue";

export default {
  name: "components",
  components: {
    "steps-bar": StepsBar,
    "highlight-match": HighlightMatch,
    "color-picker": ColorPicker,
    "check-in-status-dev-preview": CheckInStatusDevPreview,
    "birthdate-input": BirthdateInput,
    "gift-card": GiftCard,
    "feature-card": FeatureCard,
    "pointer-list": PointerList,
    "circle-list": CircleList,
    "vb-accordion": VbAccordion,
    "vb-notice": VbNotice,
  },
  data() {
    return {
      search: "",
      with_arrow: true,
      money: 0,
      birthdate: "",
      birthdate_min: "1900-01-01",
      birthdate_max: "2008-12-31",

      // dati d'esempio per la gift-card: i loghi sono asset del site livegift, e
      // categoria e validità le passa chi monta la card perché il componente non
      // porta copy propria. Servono a mostrarla con testata e footer pieni.
      gift_card_logo: `${process.env.BASE_URL}assets/images/livegift/products/vadobay-live.svg`,
      gift_card_logo_white: `${process.env.BASE_URL}assets/images/livegift/products/vadobay-live-white.svg`,
      gift_card_category: "hotel e soggiorni",
      gift_card_validity: VALIDITY_LABEL,

      pointer_list_steps: [
        {
          title: "Scegli la card",
          text: "Ogni Gift Card è associata al relativo prodotto o servizio.",
        },
        {
          title: "Acquista con credito welfare",
          text: "Scegli la Gift Card e conferma l'acquisto utilizzando il tuo credito welfare.",
        },
        {
          title: "Ricevi il codice",
          text: "Dopo l'acquisto riceverai una mail con le istruzioni di utilizzo.",
        },
        {
          title: 'Vai a "Ho una Gift Card" del prodotto',
          text: "Inserisci il codice ricevuto nell'apposita sezione dedicata alle Gift Card.",
        },
        {
          title: "Usa la card in prenotazione",
          text: "La card potrà essere usata nel relativo flusso di prenotazione.",
        },
      ],
      circle_list_items: [
        {
          title: "Utilizzo",
          text: "Utilizzabile secondo le regole del servizio selezionato.",
        },
        {
          title: "Validità",
          text: "La validità della gift card è di 24 mesi.",
        },
        {
          title: "Rimborsabilità",
          text: "La gift card può essere rimborsata entro 20 giorni dall'acquisto.",
        },
        {
          title: "Spendibilità",
          text: "Spendibilità limitata al prodotto associato.",
        },
      ],
      accordion_items: [
        {
          question: "Posso usare la Gift Card per più prenotazioni?",
          answer: "Sì. La Gift Card è associata a un credito a scalare.",
        },
        {
          question: "Entro quanto ricevo la Gift Card?",
          answer: "La consegna è immediata.",
        },
        {
          question: "Come si utilizza la Gift Card?",
          answer: "Dopo l'acquisto ricevi subito le istruzioni via email.",
        },
      ],
      pointer_list_short_steps: [
        { title: "Confermi l'acquisto" },
        { title: "Ricevi la Gift Card via email" },
        { title: 'Accedi a "Ho una Gift Card"' },
        { title: "Usi la card nel percorso di prenotazione" },
        { title: "Goditi il tuo acquisto con la Gift Card!" },
      ],

      step_count: 4,
      steps_demo: [],
      active_step_id: "",
      visited_step_ids: [],
      completed_step_ids: [],
      step_gates: {},
      reset_token: 0,

      steps_alignment: "row",
      steps_color: "var(--primary)",
      steps_symbol_size: 25,
      steps_line_thickness: 2.5,
      alignment_options: [
        { value: "row", text: "Simbolo → etichetta" },
        { value: "row-reverse", text: "Etichetta → simbolo" },
        { value: "column", text: "Simbolo sopra etichetta" },
        { value: "column-reverse", text: "Etichetta sopra simbolo" },
      ],
      color_options: [
        { value: "var(--primary)", text: "Primary" },
        { value: "var(--secondary)", text: "Secondary" },
        { value: "var(--success)", text: "Success" },
        { value: "var(--info)", text: "Info" },
        { value: "var(--warning)", text: "Warning" },
      ],

      // one per section: each picker drives only its own preview
      checkbox_color: "",
      switch_color: "",
      checkbox_color_options: [
        { value: "", text: "Default (--primary)" },
        { value: "--primary", text: "--primary" },
        { value: "--secondary", text: "--secondary" },
        { value: "--success", text: "--success" },
        { value: "--info", text: "--info" },
        { value: "--warning", text: "--warning" },
        { value: "--danger", text: "--danger" },
      ],

      popovers: ["default", "dark", "primary", "secondary", "info", "danger"].flatMap(
        (variant) =>
          ["top", "bottom", "left", "right"].map((placement) => ({
            placement,
            variant,
          }))
      ),

      loading_messages,
      show_loader_modal: false,
    };
  },
  computed: {
    steps_customizations() {
      return {
        steps_alignment: this.steps_alignment,
        steps_color: this.steps_color,
        symbol_size: `${this.steps_symbol_size}px`,
        line_thickness: `${this.steps_line_thickness}px`,
      };
    },
    active_step() {
      return this.steps_demo.find((s) => s.id === this.active_step_id) || null;
    },
    active_step_index() {
      return this.steps_demo.findIndex((s) => s.id === this.active_step_id);
    },
    is_last_step() {
      return this.active_step_index === this.steps_demo.length - 1;
    },
    can_continue() {
      return this.step_gates[this.active_step_id] === true;
    },
    continue_label() {
      return this.is_last_step ? "Completa" : "Continua";
    },
  },
  created() {
    this.build_steps_demo();
  },
  methods: {
    is_hidden(title) {
      if (!this.search) return false;
      return !title.toLowerCase().includes(this.search.toLowerCase());
    },
    toggle_popover_with_arrow() {
      this.with_arrow = !this.with_arrow;
    },
    build_steps_demo() {
      const count = Math.min(12, Math.max(1, Number(this.step_count) || 1));
      this.step_count = count;
      this.steps_demo = Array.from({ length: count }, (_, index) => ({
        id: `step-${index + 1}`,
        name: `Step ${index + 1}`,
      }));
      this.reset_steps_demo();
    },
    set_active_step(step_id) {
      if (!step_id || step_id === this.active_step_id) return;
      if (this.visited_step_ids.indexOf(step_id) < 0) return;
      this.active_step_id = step_id;
    },
    set_step_gate(step_id, value) {
      this.step_gates = { ...this.step_gates, [step_id]: value };
    },
    mark_completed(step_id) {
      if (!step_id) return;
      if (this.completed_step_ids.indexOf(step_id) >= 0) return;
      this.completed_step_ids = [...this.completed_step_ids, step_id];
    },
    advance() {
      if (!this.can_continue) return;
      this.mark_completed(this.active_step_id);
      if (this.is_last_step) return;
      const next_step = this.steps_demo[this.active_step_index + 1];
      if (this.visited_step_ids.indexOf(next_step.id) < 0) {
        this.visited_step_ids = [...this.visited_step_ids, next_step.id];
      }
      this.active_step_id = next_step.id;
    },
    go_back() {
      if (this.active_step_index <= 0) return;
      this.active_step_id = this.steps_demo[this.active_step_index - 1].id;
    },
    reset_steps_demo() {
      const first_step = this.steps_demo[0];
      this.active_step_id = first_step ? first_step.id : "";
      this.visited_step_ids = first_step ? [first_step.id] : [];
      this.completed_step_ids = [];
      this.step_gates = this.steps_demo.reduce((gates, step) => {
        gates[step.id] = false;
        return gates;
      }, {});
      this.reset_token += 1;
    },
  },
};
</script>

<style lang="scss">

  .library {

    &__section--hidden {
      display: none;
    }

    &__steps {
      &-body {
        background-color: $white;
        border-radius: 10px;
        padding: 20px;
      }

      &-heading {
        margin-bottom: 5px;
      }

      &-count {
        max-width: 90px;
      }

      &-color {
        padding: 4px;
      }
    }

    // contenitore di anteprima di pointer-list e circle-list: la card bianca non fa parte dei componenti
    &__pointer-list-panel {
      padding: $grid-gutter-width;
      background-color: $white;
      border-radius: $border-radius-lg * 4;
    }

    &__pointer-list-heading {
      margin-bottom: $grid-gutter-width;
      font-size: 1.625rem;
      font-weight: $vb-font-weight-semibold;
      color: $gray-900;
      text-align: center;
    }

    // contenuto dello slot della gift-card blu: sta al consumatore, non al componente
    &__gift-card-value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: $white;
    }

    &__gift-card-label {
      font-size: $font-size-base * 1.875;
      font-weight: $vb-font-weight-semibold;
    }

    &__gift-card-amount {
      font-size: $font-size-base * 2.25;
      font-weight: $vb-font-weight-semibold;
    }
  }

  .custom-popover {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    border-radius: 10px;
    background-color: white;
    &--trigger {
      padding: 15px;
    }
  }
</style>
